import React from 'react';
import { startCase } from 'lodash';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { GROUP_ROLES } from '../../lib/schema.js';
import CheckboxAdapter from '../CheckboxAdapter.jsx';

const roleOptions = GROUP_ROLES.map((groupRole, index) => ({
  label: startCase(groupRole === 'viewer' ? 'group viewer' : groupRole),
  value: groupRole,
}));

const GroupRole = () => {
  return (
    <Row className="m-b-48">
      <Col xs={12}>
        <ControlLabel className="text-capitalize m-b-10">
          Who Can Access:
        </ControlLabel>
        {roleOptions.map((groupRole) => (
          <div className="m-b-20" key={`groupRole${groupRole.value}`}>
            <Field
              key={groupRole.value}
              className="m-0"
              name="groupRoles"
              label={groupRole.label}
              value={groupRole.value}
              type="checkbox"
              component={CheckboxAdapter}
            />
          </div>
        ))}
      </Col>
    </Row>
  );
};

export default GroupRole;
